import {trans as $t} from "@/vue/composables/missingTranslations";
import moment from "moment/moment";

const hideName = (name, length) => {
    const charactersLength = name.length - length;
    let hiddenChars = "";

    for (let i = 0; i < charactersLength; i++) {
        hiddenChars += "*";
    }

    return name.substring(0, length) + hiddenChars;
};

export const deviceDatesOverlapErrorMessage = (machineHistory) => {
    return `${$t(`This assigned date of this device will conflict with another patient within your organization. Please check your assigned date or check the start and end of the device on the other patient.`)}
    <br><br>
    <div style="display: flex; flex-flow: column;">
        <div>${hideName(machineHistory?.patient?.last_name, 2)}, ${hideName(machineHistory?.patient?.first_name, 3)}</div>
        <div>${$t("Assigned Date")}: ${moment(machineHistory?.start_date).format("MM/DD/YYYY")} to ${machineHistory?.end_date ? moment(machineHistory?.end_date).format("MM/DD/YYYY") : $t("Present")}</div>
        <div style="margin-top: 0.3rem;">
            <a href="/patients/${machineHistory?.patient?.id}" target="_blank">${$t("Click here")}</a>  ${$t("to access the patient records")}
        </div>
    </div>
    <br>
    <div style="font-size: 0.7rem;">
        ${$t("Please note that if your security does not allow you to access this patient record you will have to get another user within your organization to end the device.")}
    </div>`;
};
